import { render, staticRenderFns } from "./CertificateTreatmentWrapper.vue?vue&type=template&id=d635eea6&scoped=true&"
import script from "./CertificateTreatmentWrapper.vue?vue&type=script&lang=ts&"
export * from "./CertificateTreatmentWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d635eea6",
  null
  
)

export default component.exports